(() => {
  const win = /** @type {any} */ (window);

  if (win.__madesaProjetosCardActionsInitialized) return;
  win.__madesaProjetosCardActionsInitialized = true;

  function parseProjetosCardActionsI18n() {
    var defaults = {
      bundle_modal_title: "Buy kitchen bundle",
      close_aria: "Close",
      bundle_add_all: "Add all products to cart",
      bundle_empty: "No items found for this kit.",
      product_fallback: "Product",
      pix_line: "Pay in full with PIX (10% OFF)",
      add_item_aria: "Add __DM_TITLE__ to cart",
      toast_product_added: "Product added to cart!",
      toast_cart_error: "Could not add the product to your cart.",
      toast_no_items: "No items available to add.",
      toast_kit_added: "All kit products were added!",
      toast_kit_error: "Could not add kit products.",
      cart_add_failed: "Could not add to cart",
      money_locale: "pt-BR",
      money_currency: "BRL",
    };
    var el = document.getElementById("madesa-projetos-card-actions-i18n");
    if (!el || !String(el.textContent || "").trim()) {
      return defaults;
    }
    try {
      var parsed = /** @type {Record<string, unknown>} */ (JSON.parse(el.textContent));
      /** @type {typeof defaults} */
      var out = Object.assign({}, defaults);
      var pk;
      for (pk in parsed) {
        if (
          Object.prototype.hasOwnProperty.call(parsed, pk) &&
          Object.prototype.hasOwnProperty.call(defaults, pk) &&
          parsed[pk] != null &&
          parsed[pk] !== ""
        ) {
          out[/** @type {keyof typeof defaults} */ (pk)] = String(parsed[pk]);
        }
      }
      return out;
    } catch (e) {
      return defaults;
    }
  }

  var PA = parseProjetosCardActionsI18n();

  const minicartToggle = /** @type {HTMLInputElement | null} */ (document.querySelector("#toggle-minicart"));
  const cartUrl = (win.routes && win.routes.cart_url) || "/cart";
  const currencyFormatter = new Intl.NumberFormat(PA.money_locale || "pt-BR", {
    style: "currency",
    currency: PA.money_currency || "BRL",
  });

  /** @type {HTMLElement | null} */
  let bundleModal = null;

  /** @type {HTMLElement | null} */
  let bundleModalList = null;

  /** @type {HTMLButtonElement | null} */
  let bundleModalAddAll = null;

  /** @type {HTMLButtonElement | null} */
  let activeAddButton = null;

  function updateMiniCartSection() {
    fetch(`${cartUrl}?section_id=bf-minicart`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const targetElement = document.querySelector("#shopify-section-bf-minicart");
        const sourceElement = html.querySelector("#shopify-section-bf-minicart");

        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function refreshCartUI() {
    if (typeof win.refreshCart === "function") {
      win.refreshCart();
      return;
    }

    updateMiniCartSection();

    if (minicartToggle) {
      minicartToggle.checked = true;
    }
  }

  /**
   * @param {string} message
   * @param {'success' | 'error'} type
   */
  function showFeedback(message, type = "success") {
    document.dispatchEvent(
      new CustomEvent("toast:show", {
        detail: {
          message,
          type,
        },
      }),
    );
  }

  /**
   * @param {number} valueInCents
   */
  function formatMoney(valueInCents) {
    return currencyFormatter.format((Number(valueInCents) || 0) / 100);
  }

  /**
   * @param {string} value
   */
  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  /**
   * @param {string | undefined} value
   * @returns {Map<number, number>}
   */
  function parseBundleQuantities(value) {
    if (!value) return new Map();

    try {
      const parsed = JSON.parse(value);

      if (typeof parsed !== 'object' || parsed === null) return new Map();

      const quantities = new Map();
      
      for (const [gid, qty] of Object.entries(parsed)) {
        // Extract product ID from GID (gid://shopify/Product/7515054899303)
        const match = String(gid).match(/\/Product\/(\d+)/);
        if (match && match[1]) {
          const productId = Number(match[1]);
          const quantity = Number(qty) || 1;
          quantities.set(productId, quantity);
        }
      }

      return quantities;
    } catch (error) {
      console.error("Erro ao interpretar bundle.quantities:", error);
      return new Map();
    }
  }

  /**
   * @param {string | undefined} productsValue
   * @param {string | undefined} quantitiesValue
   */
  function parseBundleProducts(productsValue, quantitiesValue) {
    if (!productsValue) return [];

    try {
      const parsed = JSON.parse(productsValue);

      if (!Array.isArray(parsed)) return [];

      const quantities = parseBundleQuantities(quantitiesValue);

      return parsed
        .filter((item) => item && item.variant_id)
        .map((item) => ({
          ...item,
          quantity: quantities.get(Number(item.id)) || 1,
        }));
    } catch (error) {
      console.error("Erro ao interpretar bundle.products:", error);
      return [];
    }
  }

  /**
   * @param {Array<{id:number, quantity:number}>} items
   */
  function addItemsToCart(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.status && json.status >= 400) {
          throw new Error(json.description || PA.cart_add_failed);
        }

        refreshCartUI();
        return json;
      });
  }

  function getBundleModal() {
    if (bundleModal) return bundleModal;

    const container = document.createElement("div");
    container.className = "madesa-bundle-modal";
    container.setAttribute("aria-hidden", "true");
    container.innerHTML = `
      <div class="madesa-bundle-modal__overlay" data-bundle-modal-close></div>
      <div class="madesa-bundle-modal__drawer" role="dialog" aria-modal="true" aria-labelledby="madesa-bundle-modal-title">
        <div class="madesa-bundle-modal__header">
          <h3 class="madesa-bundle-modal__title" id="madesa-bundle-modal-title">${PA.bundle_modal_title}</h3>
          <button class="madesa-bundle-modal__close" type="button" aria-label="${PA.close_aria}" data-bundle-modal-close>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M18 6L6 18M6 6L18 18" stroke="#131614" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        <div class="madesa-bundle-modal__body" data-bundle-modal-list></div>
        <div class="madesa-bundle-modal__footer">
          <button type="button" class="madesa-bundle-modal__add-all" data-bundle-add-all>
            ${PA.bundle_add_all}
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(container);

    bundleModal = container;
    bundleModalList = /** @type {HTMLElement | null} */ (container.querySelector("[data-bundle-modal-list]"));
    bundleModalAddAll = /** @type {HTMLButtonElement | null} */ (container.querySelector("[data-bundle-add-all]"));

    return container;
  }

  function openBundleModal() {
    const modal = getBundleModal();
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("madesa-bundle-modal-open");
  }

  function closeBundleModal() {
    const modal = getBundleModal();
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("madesa-bundle-modal-open");
  }

  /**
   * @param {Array<any>} bundleProducts
   * @param {string | undefined} bundleQuantitiesValue
   */
  function setModalProducts(bundleProducts, bundleQuantitiesValue) {
    const modal = getBundleModal();
    modal.dataset.bundleProducts = JSON.stringify(bundleProducts);
    modal.dataset.bundleQuantities = bundleQuantitiesValue || '';

    if (!bundleModalList) return;

    if (!bundleProducts.length) {
      bundleModalList.innerHTML = `
        <div class="madesa-bundle-modal__empty">
          ${PA.bundle_empty}
        </div>
      `;

      if (bundleModalAddAll) {
        bundleModalAddAll.disabled = true;
      }
      return;
    }

    bundleModalList.innerHTML = bundleProducts
      .map((product, index) => {
        const title = product.title || PA.product_fallback;
        const image = product.image || "";
        const price = Number(product.price) || 0;
        const compareAtPrice = Number(product.compare_at_price) || 0;
        const available = Boolean(product.available);
        const quantity = product.quantity || 1;
        const safeTitle = escapeHtml(title);
        const safeImage = escapeHtml(image);
        const titleWithQuantity = `${safeTitle} - x${quantity}`;

        return `
          <article class="madesa-bundle-modal__item">
            <div class="madesa-bundle-modal__item-image-wrap">
              ${image ? `<img src="${safeImage}" alt="${safeTitle}" class="madesa-bundle-modal__item-image" loading="lazy">` : `<div class="madesa-bundle-modal__item-image madesa-bundle-modal__item-image--placeholder" aria-hidden="true"></div>`}
            </div>
            <div class="madesa-bundle-modal__item-content">
              <p class="madesa-bundle-modal__item-title">${titleWithQuantity}</p>
              <div class="madesa-bundle-modal__item-pricing">
                <span class="madesa-bundle-modal__item-price">${formatMoney(price)}</span>
                ${compareAtPrice > price ? `<span class="madesa-bundle-modal__item-compare">${formatMoney(compareAtPrice)}</span>` : ""}
              </div>
              <p class="madesa-bundle-modal__item-pix">${PA.pix_line}</p>
            </div>
            <button
              type="button"
              class="madesa-bundle-modal__item-add"
              data-bundle-add-one
              data-bundle-index="${index}"
              ${available ? "" : "disabled"}
              aria-label="${PA.add_item_aria.split("__DM_TITLE__").join(titleWithQuantity)}"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21" fill="none" aria-hidden="true">
                <path d="M6.77441 17.4941C7.67355 17.4942 8.40234 18.2229 8.40234 19.1221C8.40228 20.0212 7.67351 20.75 6.77441 20.75C5.87531 20.75 5.14655 20.0212 5.14648 19.1221C5.14648 18.2229 5.87527 17.4941 6.77441 17.4941ZM15.9941 17.4941C16.7059 17.4942 17.3091 17.9515 17.5303 18.5879C17.6687 18.724 17.7549 18.9127 17.7549 19.1221C17.7549 19.3313 17.6684 19.5193 17.5303 19.6553C17.3093 20.292 16.7061 20.7499 15.9941 20.75C15.095 20.75 14.3663 20.0212 14.3662 19.1221C14.3662 18.2229 15.095 17.4941 15.9941 17.4941ZM17.25 0C20.0114 0 22.25 2.23858 22.25 5C22.25 7.52411 20.3796 9.61106 17.9492 9.95117L16.9053 11.9678C16.6256 12.5081 16.0683 12.8476 15.46 12.8477H7.58887L6.2334 14.6553C6.1702 14.7396 6.22971 14.8591 6.33496 14.8594H18.1895C18.6033 14.8596 18.9392 15.1955 18.9395 15.6094C18.9395 16.0234 18.6035 16.3591 18.1895 16.3594H6.33496C4.99362 16.3591 4.22833 14.828 5.0332 13.7549L6.35352 11.9932L3.56543 5.46191L2.38477 2.82324L2.36426 2.79297C2.34033 2.76612 2.30564 2.75 2.26855 2.75H0.75C0.335786 2.75 0 2.41421 0 2C0 1.58579 0.335786 1.25 0.75 1.25H2.26855C2.89634 1.25 3.46822 1.61104 3.73828 2.17773L3.74609 2.19434L4.73145 4.39746L12.3027 4.27051C12.6558 1.85485 14.7364 0 17.25 0ZM5.37695 5.88574L7.70898 11.3477H15.46C15.5077 11.3476 15.5513 11.3207 15.5732 11.2783L16.2832 9.90625C14.2323 9.50442 12.6301 7.8491 12.3086 5.77051L5.37695 5.88574ZM17.25 2.25C16.8358 2.25 16.5 2.58579 16.5 3V4.25H15.25C14.8358 4.25 14.5 4.58579 14.5 5C14.5 5.34723 14.7363 5.63921 15.0566 5.72461C15.1183 5.74103 15.1831 5.75 15.25 5.75H16.5V7C16.5 7.41421 16.8358 7.75 17.25 7.75C17.3043 7.75 17.3572 7.74435 17.4082 7.7334C17.7463 7.66063 18 7.3598 18 7V5.75H19.25C19.4526 5.75 19.6365 5.66958 19.7715 5.53906C19.9124 5.40271 20 5.21158 20 5C20 4.58579 19.6642 4.25 19.25 4.25H18V3C18 2.58579 17.6642 2.25 17.25 2.25Z" fill="#131614"/>
                <path d="M6.77441 17.4941C7.67355 17.4942 8.40234 18.2229 8.40234 19.1221C8.40228 20.0212 7.67351 20.75 6.77441 20.75C5.87531 20.75 5.14655 20.0212 5.14648 19.1221C5.14648 18.2229 5.87527 17.4941 6.77441 17.4941ZM15.9941 17.4941C16.7059 17.4942 17.3091 17.9515 17.5303 18.5879C17.6687 18.724 17.7549 18.9127 17.7549 19.1221C17.7549 19.3313 17.6684 19.5193 17.5303 19.6553C17.3093 20.292 16.7061 20.7499 15.9941 20.75C15.095 20.75 14.3663 20.0212 14.3662 19.1221C14.3662 18.2229 15.095 17.4941 15.9941 17.4941ZM17.25 0C20.0114 0 22.25 2.23858 22.25 5C22.25 7.52411 20.3796 9.61106 17.9492 9.95117L16.9053 11.9678C16.6256 12.5081 16.0683 12.8476 15.46 12.8477H7.58887L6.2334 14.6553C6.1702 14.7396 6.22971 14.8591 6.33496 14.8594H18.1895C18.6033 14.8596 18.9392 15.1955 18.9395 15.6094C18.9395 16.0234 18.6035 16.3591 18.1895 16.3594H6.33496C4.99362 16.3591 4.22833 14.828 5.0332 13.7549L6.35352 11.9932L3.56543 5.46191L2.38477 2.82324L2.36426 2.79297C2.34033 2.76612 2.30564 2.75 2.26855 2.75H0.75C0.335786 2.75 0 2.41421 0 2C0 1.58579 0.335786 1.25 0.75 1.25H2.26855C2.89634 1.25 3.46822 1.61104 3.73828 2.17773L3.74609 2.19434L4.73145 4.39746L12.3027 4.27051C12.6558 1.85485 14.7364 0 17.25 0ZM5.37695 5.88574L7.70898 11.3477H15.46C15.5077 11.3476 15.5513 11.3207 15.5732 11.2783L16.2832 9.90625C14.2323 9.50442 12.6301 7.8491 12.3086 5.77051L5.37695 5.88574ZM17.25 2.25C16.8358 2.25 16.5 2.58579 16.5 3V4.25H15.25C14.8358 4.25 14.5 4.58579 14.5 5C14.5 5.34723 14.7363 5.63921 15.0566 5.72461C15.1183 5.74103 15.1831 5.75 15.25 5.75H16.5V7C16.5 7.41421 16.8358 7.75 17.25 7.75C17.3043 7.75 17.3572 7.74435 17.4082 7.7334C17.7463 7.66063 18 7.3598 18 7V5.75H19.25C19.4526 5.75 19.6365 5.66958 19.7715 5.53906C19.9124 5.40271 20 5.21158 20 5C20 4.58579 19.6642 4.25 19.25 4.25H18V3C18 2.58579 17.6642 2.25 17.25 2.25Z" stroke="#131614"/>
              </svg>
            </button>
          </article>
        `;
      })
      .join("");

    if (bundleModalAddAll) {
      bundleModalAddAll.disabled = !bundleProducts.some((product) => product.available);
    }
  }

  /**
   * @param {HTMLButtonElement} button
   */
  function addProductToCart(button) {
    const variantId = button.dataset.variantId;

    if (!variantId) return;

    activeAddButton = button;
    button.setAttribute("disabled", "disabled");

    addItemsToCart([
      {
        id: Number(variantId),
        quantity: 1,
      },
    ])
      .then(() => {
        showFeedback(PA.toast_product_added, "success");
      })
      .catch((error) => {
        console.error("Erro ao adicionar produto:", error);
        showFeedback(PA.toast_cart_error, "error");
      })
      .finally(() => {
        activeAddButton?.removeAttribute("disabled");
        activeAddButton = null;
      });
  }

  /**
   * @param {HTMLButtonElement} trigger
   */
  function openBundleModalFromTrigger(trigger) {
    const bundleProducts = parseBundleProducts(
      trigger.dataset.bundleProducts,
      trigger.dataset.bundleQuantities
    );

    const quickView = trigger.closest("quick-view");
    if (quickView instanceof HTMLElement) {
      const quickViewSection = quickView.closest("#shopify-section-bf-quick-view");
      quickViewSection?.classList.remove("active");
      quickView.setAttribute("aria-hidden", "true");
      document.body.classList.remove("quick-view-open");
    }

    if (!bundleProducts.length) {
      addProductToCart(trigger);
      return;
    }

    setModalProducts(bundleProducts, trigger.dataset.bundleQuantities);
    openBundleModal();
  }

  /**
   * @param {HTMLButtonElement} button
   * @param {number} index
   */
  function addSingleBundleItem(button, index) {
    const modal = getBundleModal();
    const products = parseBundleProducts(
      modal.dataset.bundleProducts,
      modal.dataset.bundleQuantities
    );
    const product = products[index];

    if (!product || !product.variant_id || !product.available) return;

    button.disabled = true;

    addItemsToCart([
      {
        id: Number(product.variant_id),
        quantity: product.quantity || 1,
      },
    ])
      .then(() => {
        showFeedback(PA.toast_product_added, "success");
      })
      .catch((error) => {
        console.error("Erro ao adicionar item do kit:", error);
        showFeedback(PA.toast_cart_error, "error");
      })
      .finally(() => {
        button.disabled = !product.available;
      });
  }

  function addAllBundleItems() {
    const modal = getBundleModal();
    const products = parseBundleProducts(
      modal.dataset.bundleProducts,
      modal.dataset.bundleQuantities
    );

    const quantitiesByVariant = products.reduce((accumulator, product) => {
      if (!product.available || !product.variant_id) return accumulator;

      const currentQuantity = accumulator.get(product.variant_id) || 0;
      const productQuantity = product.quantity || 1;
      accumulator.set(product.variant_id, currentQuantity + productQuantity);
      return accumulator;
    }, new Map());

    const items = Array.from(quantitiesByVariant.entries()).map(([variantId, quantity]) => ({
      id: Number(variantId),
      quantity,
    }));

    if (!items.length) {
      showFeedback(PA.toast_no_items, "error");
      return;
    }

    if (bundleModalAddAll) {
      bundleModalAddAll.disabled = true;
    }

    addItemsToCart(items)
      .then(() => {
        showFeedback(PA.toast_kit_added, "success");
        closeBundleModal();
      })
      .catch((error) => {
        console.error("Erro ao adicionar kit completo:", error);
        showFeedback(PA.toast_kit_error, "error");
      })
      .finally(() => {
        if (bundleModalAddAll) {
          bundleModalAddAll.disabled = false;
        }
      });
  }

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    const modal = getBundleModal();
    if (modal.getAttribute("aria-hidden") === "false") {
      closeBundleModal();
    }
  });

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest("[data-bundle-modal-close]")) {
      event.preventDefault();
      closeBundleModal();
      return;
    }

    const bundleAddOneButton = /** @type {HTMLButtonElement | null} */ (event.target.closest("[data-bundle-add-one]"));
    if (bundleAddOneButton) {
      event.preventDefault();
      const index = Number(bundleAddOneButton.dataset.bundleIndex);
      if (!Number.isNaN(index)) {
        addSingleBundleItem(bundleAddOneButton, index);
      }
      return;
    }

    if (event.target.closest("[data-bundle-add-all]")) {
      event.preventDefault();
      addAllBundleItems();
      return;
    }

    const addButton = /** @type {HTMLButtonElement | null} */ (event.target.closest("[data-project-add-cart]"));
    if (addButton) {
      event.preventDefault();
      openBundleModalFromTrigger(addButton);
      return;
    }

    if (event.target.closest("[data-project-start-open]")) {
      event.preventDefault();
    }
  });
})();
